export default "__VITE_ASSET__mQp9d86i__"